import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { BalanceReportIncomePercentModeEnum } from '@zaoblako/shared/modules/finance/enums/balance-report-income-percent-mode.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string representations of {@link BalanceReportIncomePercentModeEnum} enumeration values */
export const BalanceReportIncomePercentModeEnumI18n: EnumI18nInterface<BalanceReportIncomePercentModeEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [BalanceReportIncomePercentModeEnum.OF_TOTAL_INCOME]: 'От общих',
    [BalanceReportIncomePercentModeEnum.OF_CLASSIFICATION]: 'От классификатора',
  },
  [I18nLocalesEnum.EN_US]: {
    [BalanceReportIncomePercentModeEnum.OF_TOTAL_INCOME]: 'Of total income',
    [BalanceReportIncomePercentModeEnum.OF_CLASSIFICATION]: 'Of classification',
  },
};
